import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as accountListActions from "../actions/account_list_actions";
import * as accountListTypes from "../types/account_list_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfAccounts(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_ACCOUNT_LIST, action.payload);
    if (res.status === 200) {
      yield put(accountListActions.getListOfAccountsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountListActions.getListOfAccountsError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountListActions.getListOfAccountsError(e));
  }
}

export default function* accountListSaga() {
  yield takeLatest(accountListTypes.getListOfAccounts.GET_LIST_OF_ACCOUNTS_REQUEST, getListOfAccounts);
}
